export default class HomepageCover {
  constructor(component) {
    this.dom = {
      $component: component,
      $fadeIns: document.querySelectorAll('.js-fadeIn')
    }
    this.state = {
      desktopAnimatingClass: 'isAnimatingDesktop',
      mobileAnimatingClass: 'isAnimatingMobile',
      hasAnimatedClass: 'hasAnimated',
      fadedInClass: 'fadedIn',
      isMobile: window.innerWidth < 1110
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    window.addEventListener('DOMContentLoaded', this.revealCover.bind(this))
  }

  async revealCover() {
    const {dom, state} = this
    let animatingClass = state.desktopAnimatingClass
    let fadeInFunction = this.fadeInDesktop.bind(this)

    if (state.isMobile) {
      animatingClass = state.mobileAnimatingClass
      fadeInFunction = this.fadeInMobile.bind(this)
    }

    await new Promise(resolve => setTimeout(resolve, 500))
    dom.$component.classList.add(animatingClass)

    setTimeout(() => {
      dom.$component.classList.add(state.hasAnimatedClass)
      fadeInFunction()
    }, 1000)
  }

  async fadeInDesktop() {
    const {dom, state} = this
    const orderMap = {}

    dom.$fadeIns.forEach(elem => {
      const order = elem.dataset.fadeIndex
      if (orderMap[order]) {
        orderMap[order].push(elem)
      } else {
        orderMap[order] = [elem]
      }
    })

    const sortedOrderKeys = Object.keys(orderMap)
      .sort((a, b) => a - b)

    for (let i of sortedOrderKeys) {
      orderMap[i].forEach(elem => elem.classList.add(state.fadedInClass))
      await new Promise(resolve => setTimeout(resolve, 500))
    }
  }

  fadeInMobile() {
    const {dom, state} = this
    dom.$fadeIns.forEach(elem => elem.classList.add(state.fadedInClass))
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.HomepageCover = this
  }
}
